import modalStyle from "../../components/Vehicles/RequestVehicle/index.module.css";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import BreadCrumbs from "../../components/General/BreadCrumbs";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import SingleUsedVehicleCard from "../../components/Vehicles/SingleUsedVehicleCard";
import { selectUser } from "../../store/userSlice";
import { VehicleNames } from "../../utils/GeneralTypes";
import style from "./index.module.css";
import VehicleTypesControllers from "../../components/General/VehiclesControllers";
import { deleteUserVehicle, getMyVehicles } from "../../utils/fetcher";
import { useScrollToTop } from "../../utils/generalUtils";
import EmptyContent from "../../components/General/EmptyContent";
import { Link, useHistory } from "react-router-dom";
import Modal from "../../components/UI/Modal";
import Button from "../../components/UI/Button";
import { Success, Warning } from "../../components/Icons";
import { useTranslation } from "../../hooks/useTranslation";

const MyVehicles = ({ vehicleNames }: ComponentPropsType) => {
  const { user } = useSelector(selectUser);
  const { locale } = useTranslation();
  const history = useHistory();

  const initialMount = useRef<boolean>(true);

  useScrollToTop();

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: {
      vehicles: any;
    };
  }>({
    isFetching: true,
    data: {
      vehicles: [],
    },
  });

  const [deletionState, setDeletionState] = useState<{
    id: number;
    isDeleting: boolean;
    success: boolean;
    error: string;
  }>({
    id: -1,
    isDeleting: false,
    success: false,
    error: "",
  });

  useEffect(() => {
    if (!user) {
      history.replace("/sign");
    } else {
      if (!initialMount.current) {
        setComponentData((current) => ({
          ...current,
          isFetching: true,
        }));
      }
      initialMount.current = false;
      (async () => {
        const data = {
          vehicles: null,
        };
        await getMyVehicles(vehicleNames.single)
          .then((res) => {
            data.vehicles = res.data.vehicles.data;
          })
          .catch((error) => {});
        setComponentData({
          isFetching: false,
          data,
        });
      })();
    }
  }, [vehicleNames, user, history]);

  const onDeleteMyVehicle = useCallback(async () => {
    setDeletionState((current) => ({
      isDeleting: true,
      id: current.id,
      error: "",
      success: false,
    }));
    let success = false,
      error = "";
    await deleteUserVehicle(vehicleNames.single, deletionState.id)
      .then(() => {
        success = true;
        setComponentData((currentState) => ({
          ...currentState,
          data: {
            ...currentState.data,
            vehicles: currentState.data.vehicles.filter((el: any) => el.id.toString() !== deletionState.id.toString()),
          },
        }));
      })
      .catch((err) => {
        error = err?.response?.data?.message || err?.response?.message || locale("error_occured");
      });
    setDeletionState((current) => ({
      isDeleting: false,
      id: success ? -1 : current.id,
      error,
      success,
    }));
  }, [vehicleNames, deletionState, locale]);

  const onCloseDeletionModal = useCallback(() => {
    setDeletionState((prev) => ({
      ...prev,
      id: -1,
      isDeleting: false,
    }));
  }, []);
  const onCloseSuccessModal = useCallback(() => {
    setDeletionState((prev) => ({
      ...prev,
      success: false,
      error: "",
    }));
  }, []);

  return (
    <>
      {deletionState.id !== -1 && (
        <Modal onClose={onCloseDeletionModal}>
          <div className={style.modal}>
            <p className={style.modal_title}>{locale("sure_to_delete")}</p>
            {deletionState.error && <p className={style.modal_error}>{deletionState.error}</p>}
            <div className={style.modal_ctas}>
              <Button
                styleType="primary"
                onClick={onDeleteMyVehicle}
                disabled={deletionState.isDeleting}
                isLoading={deletionState.isDeleting}
              >
                {locale("remove")}
              </Button>
              <Button styleType="primary_black" onClick={onCloseDeletionModal} disabled={deletionState.isDeleting}>
                {locale("cancel")}
              </Button>
            </div>
          </div>
        </Modal>
      )}
      {(deletionState.success || deletionState.error) && (
        <Modal onClose={onCloseSuccessModal}>
          <div className={modalStyle.modal}>
            <div className={modalStyle.modal_response}>
              {deletionState.success ? (
                <Success width="50" height="50" color="#35b545" />
              ) : (
                <Warning width="50" height="50" color="#dc0000" />
              )}
              <p>{deletionState.success ? locale("removed_listing_successfuly") : deletionState.error}</p>
            </div>
          </div>
        </Modal>
      )}
      {/* <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <BreadCrumbs
              pages={[
                { text: locale("home"), link: "/" },
                {
                  text: locale("my_vehicles"),
                  link: "",
                },
              ]}
            />
          </div>
        </div>
      </div> */}
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <div className={style.section_header}>
              <h3 className="main_section__title">{locale("my_vehicles")}</h3>
              <VehicleTypesControllers baseLink="/my-vehicles" active={vehicleNames.single} />
            </div>
            <div className={`${style.all_vehicles} row`}>
              {componentData.isFetching && (
                <div className="col-12">
                  <LoadingSkeleton count={8} />
                </div>
              )}
              {!componentData.isFetching &&
                componentData.data.vehicles &&
                componentData.data.vehicles.length > 0 &&
                componentData.data.vehicles.map((item: any) => (
                  <div className="col-md-4 col-sm-6" key={item.id}>
                    <SingleUsedVehicleCard
                      showroom={{
                        is_showroom: false,
                        image: "",
                        link: "",
                      }}
                      image={item?.images?.[0]?.image}
                      link={`/used-${vehicleNames.plural}/${vehicleNames.single}/${item.id}`}
                      isFeatured={item.listing_period.is_featured}
                      date={item?.created_at}
                      location={item?.region ? `${item?.region?.name}, ${item?.region?.city?.name}` : ""}
                      name={`${item?.model?.brand?.name} ${item?.model?.name} ${item?.model?.year}`}
                      price={item?.price}
                      isMyVehiclesPage={true}
                      myVehicleEditLink={`/my-vehicles/${vehicleNames.plural}/edit/${item?.id}`}
                      myVehicleDeleteCb={() =>
                        setDeletionState((current) => ({
                          ...current,
                          id: item.id,
                        }))
                      }
                    />
                  </div>
                ))}
              {!componentData.isFetching && (
                <div className="col-md-4 col-sm-6">
                  <Link to={`/sell-vehicle/${vehicleNames.single}`} className={style.add_vehicle_card}>
                    <div className={style.add_card_inner}>
                      <div className={style.add_icon}>+</div>
                      <p className={style.add_text}>
                        {locale("add_your_car").replace("%vehicles%", locale(vehicleNames.plural))}
                      </p>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyVehicles;

type ComponentPropsType = {
  vehicleNames: VehicleNames;
};
